export const MAX_COMENTARIO = 500;

export const TEXTOS_REPORTAR_PROBLEMA = {
  titulo: "Reportar un problema a FH",
  placeholder: "Describe el problema que encontraste...",
  cancelar: "Cancelar",
  enviar: "Enviar",
  enviando: "Enviando...",
  atajo: "Ctrl+Enter para enviar",
} as const;

export const COLOR_REPORTAR_PROBLEMA = {
  principal: "#f44336",
  hover: "#c62828",
  textoHover: "#180605",
  fondo: "#ffffff",
  disabled: "#bcbcbc",
  borde: "rgba(15,23,42,0.08)",
} as const;

export const ANCHO_POPOVER_REPORTE = 340;
export const TAMANO_FLECHA = 12;
export const POSICION_FLECHA = 24;
